<template>
    <div class="d-flex w-100">
        <div class="col-md-3">
          <QmaReportPainel :report="2" @quantitativos="quantitativos" ref="painelQMA"></QmaReportPainel>
          <QmaReportFiltro :report="2" @search="search"></QmaReportFiltro>
        </div>
        <div class="col-md-9">
          <QmaReport :report="2" @dataRelatoioQmaLength="dataRelatoioQmaLength" @contagemRelatorio="contagemRelatorio" ref="tableRelatorioQMA"></QmaReport>
        </div>
    </div>
  </template>

<script>
import ActionsForm from '@/shared/mixins/actionsForm'
import QmaReport from '../components/qmaReport/qmaReport.vue'
import QmaReportFiltro from '../components/qmaReportTable/components/qmaReportFiltro/qmaReportFiltro.vue'
import QmaReportPainel from '../components/qmaReportTable/components/qmaPainelReport/qmaPainelReport.vue'
import HeadDetailsGama from '@/views/private/realestate/components/HeadDetails.vue'

export default {
  name: 'qmaReportPivs',
  components: {QmaReport, QmaReportFiltro, HeadDetailsGama, QmaReportPainel},
  mixins: [ActionsForm],
  data () {
    return {
      contagem: 0,
      totalRelatorio: 0
    }
  },
  methods: {
    search (data) {
      this.$refs.tableRelatorioQMA.formSearch = data
      this.$refs.tableRelatorioQMA.search(data.Fluxo, data)
      this.$refs.painelQMA.formSearch = data
      this.$refs.painelQMA.onLoad()
    },
    quantitativos (data) {
      this.$refs.tableRelatorioQMA.quantitativosPDF = data
    }
  }
}

</script>

  <style scoped>
   .col-md-3{
    padding-right: 0;
    padding-left: 0;
   }
  </style>



// WEBPACK FOOTER //
// src/views/private/qma/qmaReport/qmaReportPivs/qmaReportPivs.vue